import { useSelector } from 'react-redux';
import { RootState } from 'store';
import Label from './Label';

export function FacetLabels() {
	const { allRoofSegs } = useSelector(
		(state: RootState) => state.roofData.data
	);

	const { showFacetLabels } = useSelector(
		(state: RootState) => state.roofEditData.data
	);

	return (
		<>
			{allRoofSegs.map(rs => (
				<Label
					key={rs.id}
					simplifiedHullCoords={rs.simplifiedHullCoords}
					label={rs.label}
					visible={showFacetLabels}
					roofSegId={rs.id}
				/>
			))}
		</>
	);
}
